module.exports = __webpack_public_path__ + "static/media/07_balloon_green.56839078.png";